import React, { useEffect, useState } from "react";
import MainBg from "../../components/Mainbg";
import { Swiper, SwiperSlide, Navigation } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import {
  Tooltip,
  Cell,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  LineChart,
  Line,
} from "recharts";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import BaseImage from "../../assets/images/dasboard/base.webp";
import { GET_TRACK_WORKOUT } from "../../config/ApisCollection";
import calwork from "../../assets/images/dasboard/calwork.webp";
import workwal from "../../assets/images/dasboard/workwal.webp";
import {
  monthlist,
  getDatesWithDayNames,
  WeekInMonth,
} from "../../function/functions";
import tracknotfound from "../../assets/images/track-not-found.png";
import {
  DaySlideSection,
  DayWeekTabSection,
  NotFound,
  TrackDateFilterSection,
  WeekSlideSection,
} from "../../components/TrackCommonSection";

const WorkoutTrack = ({ weekStart = "Sunday" }) => {
  const accessToken = secureLocalStorage.getItem("accessToken");
  // Update current date, month, and year on component mount
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed and should be 2 digits
  const day = String(now.getDate()).padStart(2, "0"); // Ensure day is 2 digits
  const current_date = `${year}-${month}-${day}`; // Ensure day is 2 digits
  // const dayOfWeek = now.getDay();
  const dayOfWeek = parseInt(day);
  // const current_month = month;
  const current_dayinweek = 3;
  // Get the current week of the month
  const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const firstWeekday = firstDayOfMonth.getDay(); // Day of the week for the 1st of the month
  const currentWeekfind = Math.ceil((now.getDate() + firstWeekday) / 7); // Week number in the month

  const [dataTab, setDataTab] = useState("Daily");
  const [bardata, setBarData] = useState([]);
  const [linedata, setLineData] = useState([]);
  const [activeDayTab, setActiveDayTab] = useState(current_date || null);
  const [activeWeekTab, setActiveWeekTab] = useState(currentWeekfind - 1);
  const [currentMonth, setCurrentMonth] = useState(month || null);
  const [currentYear, setCurrentYear] = useState(year || null);
  const [reportData, setReportData] = useState(null);
  const [workout_data, setWorkoutData] = useState(null);

  const weeklist = ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"];
  // Function to get the current week with dates and day names

  const handleChange = (event) => {
    setCurrentMonth(event.target.value);
  };

  const GetTrackReport = async () => {
    const getParams = {
      month: currentMonth,
      year: currentYear,
    };

    const getHeaders = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.post(
        GET_TRACK_WORKOUT,
        getParams,
        getHeaders
      );

      setReportData(response.data);
      setWorkoutData(response.data);

      let bar_data_arr = [];
      const curweek = "week" + (activeWeekTab + 1);

      response.data &&
        response.data?.videoLogsweek &&
        response.data?.videoLogsweek[currentYear + "-" + currentMonth] &&
        response.data?.videoLogsweek[currentYear + "-" + currentMonth][
          curweek
        ]?.dailyData?.forEach((item, index) => {
          const shortFormatedYmd = new Date(
            item?.item1?.logDate
          ).toLocaleString("en-US", {
            day: "numeric",
            month: "short",
          });
          bar_data_arr.push({
            name: shortFormatedYmd,
            Calorie: item?.item1?.calories || 0,
            Duration: item?.item1?.playduration || 0,
            amt: 0,
          });
        });

      setBarData(bar_data_arr);

      // Day Line data
      let line_data_arr = [
        {
          time: 0,
        },
      ];

      response.data?.videoLogs?.forEach((item, index) => {
        const shortFormatedYmd = new Date(item?.logDate).toLocaleString(
          "en-US",
          {
            day: "numeric",
            month: "numeric",
            year: "numeric",
          }
        );
        const shortFormatedYmd_activeDayTab = new Date(
          activeDayTab
        ).toLocaleString("en-US", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        });

        if (shortFormatedYmd == shortFormatedYmd_activeDayTab) {
          line_data_arr.push({
            name: item.name?.slice(0, 3),
            time: item.playduration || 0,
          });
        }
      });

      setLineData(line_data_arr);
    } catch (error) {
      // console.log(error);
    }
  };

  // const currentWeek = getCurrentWeek(weekStart);
  const currentWeek = getDatesWithDayNames(year, currentMonth - 1);

  useEffect(() => {
    GetTrackReport();
  }, [activeDayTab, currentMonth, activeWeekTab]);

  return (
    <MainBg>
      <div className="container lg:w-1/4 md:w-1/3 w-full m-auto">
        <TrackDateFilterSection
          currentMonth={currentMonth}
          month={month}
          year={year}
          monthlist={monthlist}
          setCurrentYear={setCurrentYear}
          currentYear={currentYear}
          handleChange={handleChange}
        />

        <DayWeekTabSection dataTab={dataTab} setDataTab={setDataTab} />
      </div>
      {dataTab === "Daily" ? (
        <>
          {/* Daily based data report  */}
          {/* Date and day tabs  */}
          <DaySlideSection
            activeDayTab={activeDayTab}
            currentWeek={currentWeek}
            dayOfWeek={dayOfWeek}
            setActiveDayTab={setActiveDayTab}
          />

          <>
            {/* Workout list set left  */}
            <div className="container mx-auto p-4 py-20">
              {/* Table section  */}

              {linedata && linedata?.length >= 2 ? (
                <>
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <div>
                      <div className="py-5">
                        <h1 className="text-xl text-black font-bold">
                          Workouts
                        </h1>
                        {/* <p className="text-gray text-xs">8.00am to 11.30am</p> */}
                      </div>
                      <div className="mt-2 grid xl:grid-cols-2 lg:grid-cols-2  sm:grid-cols-2 md:grid-cols-1  grid-cols-1 gap-5 ">
                        {workout_data &&
                          workout_data?.videoLogs?.map((cl_row, index) => {
                            const shortFormatedYmd = new Date(
                              cl_row?.logDate
                            ).toLocaleString("en-US", {
                              day: "numeric",
                              month: "numeric",
                              year: "numeric",
                            });
                            const shortFormatedYmd_activeDayTab = new Date(
                              activeDayTab
                            ).toLocaleString("en-US", {
                              day: "numeric",
                              month: "numeric",
                              year: "numeric",
                            });

                            if (
                              shortFormatedYmd == shortFormatedYmd_activeDayTab
                            ) {
                              return (
                                <div key={index}>
                                  <div className="mt-2">
                                    <h1 className="font-bold">
                                      {cl_row?.title?.toUpperCase()}
                                    </h1>
                                  </div>

                                  <div className="melasbox flex" key={index}>
                                    <div>
                                      <img
                                        loading="lazy"
                                        src={cl_row?.imageUrl}
                                        alt=""
                                        className=" h-[120px] w-full rounded-xl"
                                      />
                                    </div>
                                    <div className="melalin">
                                      <div className="tabetsbol text-capitalize text-[12px]">
                                        {cl_row?.name?.slice(0, 20)}
                                      </div>
                                      <div className="text-[9px] text-capitalize">
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: cl_row?.description,
                                          }}
                                        ></div>
                                      </div>
                                      <div className="flex gap-2 items-center py-2">
                                        <div className="flex gap-1 text-[8px] border border-[#FE7701] rounded p-2 items-center">
                                          <img src={workwal} />{" "}
                                          {cl_row?.playduration} sec
                                        </div>
                                        <div className="flex gap-1 text-[8px] border border-[#FE7701] rounded p-2 items-center">
                                          <img src={calwork} />{" "}
                                          {cl_row?.calories} Kcal
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                      </div>
                    </div>

                    {/* Line graph right section */}
                    <div className="lg:px-20 px-4">
                      <div className="h-[400px]">
                        {" "}
                        {/* Set fixed height in parent div */}
                        <ResponsiveContainer width="100%" height="100%">
                          <LineChart width={300} height={100} data={linedata}>
                            <defs>
                              <radialGradient
                                id="radialGradient"
                                cx="50%"
                                cy="50%"
                                r="50%"
                                fx="50%"
                                fy="50%"
                              >
                                <stop
                                  offset="20%"
                                  stopColor="rgba(115,80,255,1)"
                                />
                                <stop
                                  offset="100%"
                                  stopColor="rgba(255,153,80,1)"
                                />
                              </radialGradient>
                            </defs>
                            <Line
                              type="monotone"
                              dataKey="time"
                              stroke="url(#radialGradient)" // Use the radial gradient here
                              strokeWidth={5}
                            />
                            <Tooltip />
                            <XAxis />
                          </LineChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                reportData && <NotFound />
              )}
            </div>
          </>
        </>
      ) : (
        <>
          {/* Weekly active tab  */}
          <WeekSlideSection
            weeklist={weeklist}
            activeWeekTab={activeWeekTab}
            setActiveWeekTab={setActiveWeekTab}
            currentWeekfind={currentWeekfind}
          />
          <div className="container mx-auto p-4 py-20">
            {bardata && bardata?.length > 0 ? (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {/* Table section  */}

                <div>
                  {reportData?.videoLogsweek &&
                    reportData?.videoLogsweek?.[
                      currentYear + "-" + currentMonth
                    ] &&
                    reportData?.videoLogsweek?.[
                      currentYear + "-" + currentMonth
                    ]["week" + (activeWeekTab + 1)]?.dailyData?.map(
                      (week_day, index) => {
                        const shortFormatedYmd = new Date(
                          week_day?.item1?.logDate
                        ).toLocaleString("en-US", {
                          day: "numeric",
                          month: "short",
                        });
                        return (
                          <div key={index}>
                            <div className="flex border-b justify-between	items-center">
                              <div className="p-2 text-capitalize">
                                <p className="font-bold">{shortFormatedYmd} </p>
                                <small>
                                  {week_day?.item1?.name?.slice(0, 30)}
                                </small>
                              </div>
                              {week_day?.calori ? (
                                <div className="flex">
                                  <div className="p-2">
                                    <p className="font-bold">
                                      {week_day?.calori}kcal
                                    </p>
                                    <div className="text-xs flex items-center gap-1">
                                      <div className="h-[8px] w-[8px] bg-[#FE7701] rounded-full"></div>{" "}
                                      Burnt
                                    </div>
                                  </div>
                                  <div className="p-2">
                                    <p className="font-bold">
                                      {week_day?.item1?.duration}m
                                    </p>
                                    <div className="text-xs flex items-center gap-1">
                                      <div className="h-[8px] w-[8px] bg-[#ffdabf5c] rounded-full"></div>{" "}
                                      Duration
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <>No record</>
                              )}
                            </div>
                          </div>
                        );
                      }
                    )}
                </div>

                {/* Graph section */}
                <div>
                  <div>
                    <span className="text-[#FE7701] text-[24px]">
                      {reportData?.videoLogsweek?.[
                        currentYear + "-" + currentMonth
                      ] &&
                        reportData?.videoLogsweek?.[
                          currentYear + "-" + currentMonth
                        ]["week" + (activeWeekTab + 1)]?.total}{" "}
                      kcal
                    </span>{" "}
                    <span className="text-[#000] text-[24px]">burnt</span>
                  </div>
                  <p className="text-[#7f7f7f] text-[12px]">
                    Data from your workout logs{" "}
                  </p>
                  <div className="h-[400px]">
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        width={500}
                        height={300}
                        data={bardata}
                        margin={{
                          top: 20,
                          right: 30,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        {/* <YAxis /> */}
                        {/* <Tooltip /> */}
                        <Legend />
                        <Bar dataKey="Calorie" stackId="a" fill="#FF9950" />
                        <Bar dataKey="Duration" stackId="a" fill="#ffeee2" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>

                {/* <div className="flex justify-center">
                {workout_data ? (
                  <div className="fastiweekbox sm:w-3/4 w-full">
                    <div className="fastiweekboxtit text-sm font-semibold">
                      Your workout streak
                    </div>

                    <div className="fasweekdes mb-5">
                      {workout_data &&
                        workout_data?.workouttrack?.track.map(
                          (fs_row, index) => (
                            <div className="tabroe" key={index}>
                              <img
                                loading="lazy"
                                src={fs_row.img}
                                alt="fireac"
                                className="w-6"
                              />
                              <div className="fastiweekboxtext text-xs mt-1 font-medium">
                                {fs_row.day.slice(0, 3)}
                              </div>
                            </div>
                          )
                        )}
                    </div>

                    <div className="text-xs font-medium text-center">
                      <span className="">
                        {workout_data?.workouttrack?.trackResult}{" "}
                      </span>
                      <span className="">You’re </span>
                      <span className="text-[#fe7701]"> 40% more likely</span>
                      <span className=""> to achieve your goal</span>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div> */}
              </div>
            ) : (
              <NotFound />
            )}
          </div>
        </>
      )}
    </MainBg>
  );
};

export default React.memo(WorkoutTrack);
